<label class="container font-body-small"><div [innerHTML]="labelKey | translate"></div>
  <input type="checkbox" (change)="change($event)" [checked]="checked">
  <span class="checkmark"></span>
</label>
